import Swiper from "swiper/bundle";
import "swiper/css/bundle";

function initFeedbackSlider() {
  const swiper = new Swiper(".feedback-slider", {
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    navigation: {
      nextEl: ".feedback-slider-next",
      prevEl: ".feedback-slider-prev",
    },
    pagination: {
      el: ".feedback-slider-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 3,
      },
    },
  });
}

export { initFeedbackSlider };

function initBlogPostsSlider() {
  const swiper = new Swiper(".blog-posts-slider", {
    slidesPerView: 1.04,
    spaceBetween: 16,
    navigation: {
      nextEl: ".blog-posts-slider-next",
      prevEl: ".blog-posts-slider-prev",
    },
    pagination: {
      el: ".blog-posts-slider-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      600: {
        slidesPerView: 2.2,
      },
      1200: {
        slidesPerView: 3.1,
      },
    },
  });
}

export { initBlogPostsSlider };

function initOffersWBgSlider() {
  const swiper = new Swiper(".offers-bg-slider", {
    slidesPerView: 1.4,
    spaceBetween: 16,
    roundLengths: true,
    navigation: {
      nextEl: ".offers-bg-slider-next",
      prevEl: ".offers-bg-slider-prev",
    },
    pagination: {
      el: ".offers-bg-slider-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      600: {
        slidesPerView: 2.2,
      },
      // when window width is >= 320px
      768: {
        slidesPerView: 3.2,
      },
      // when window width is >= 480px
      1024: {
        slidesPerView: 4.2,
      },
      // when window width is >= 640px
      1200: {
        slidesPerView: 5,
      },
    },
  });
}

export { initOffersWBgSlider };

function initOfferSlider() {
  const slides = document.querySelectorAll(
    ".offer-slider .swiper-slide"
  ).length;
  const isDynamic = slides > 10;

  const swiper = new Swiper(".offer-slider", {
    slidesPerView: 1,
    spaceBetween: 16,
    roundLengths: true,
    navigation: {
      nextEl: ".offer-slider-next",
      prevEl: ".offer-slider-prev",
    },
    pagination: {
      el: ".offer-slider-pagination",
      type: "bullets",
      clickable: true,
      dynamicBullets: isDynamic,
    },
  });
}

export { initOfferSlider };

function initOfferInnerSlider() {
  const swiper = new Swiper(".offer-inner-slider", {
    slidesPerView: 1.4,
    spaceBetween: 8,
    roundLengths: true,
    breakpoints: {
      600: {
        slidesPerView: 2.4,
      },
      768: {
        slidesPerView: 2.2,
      },
    },
  });
}

export { initOfferInnerSlider };

function initContentCardsSlider() {
  const swiper = new Swiper(".content-cards-slider", {
    slidesPerView: 1.04,
    spaceBetween: 12,
    roundLengths: true,
    navigation: {
      nextEl: ".content-cards-slider-next",
      prevEl: ".content-cards-slider-prev",
    },
    pagination: {
      el: ".content-cards-slider-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      600: {
        slidesPerView: 1.04,
        spaceBetween: 16,
      },
      // when window width is >= 320px
      768: {
        slidesPerView: 2.2,
      },
      // when window width is >= 480px
      1024: {
        slidesPerView: 2.2,
      },
      // when window width is >= 640px
      1200: {
        slidesPerView: 3,
      },
    },
  });
}

export { initContentCardsSlider };

function initScreenOffersSlider() {
  const swiper = new Swiper(".screen-offers-slider", {
    slidesPerView: 4,
    slidesPerGroup: 4,
    grid: {
      rows: 2,
      fill: "row",
    },
    loop: true,
    autoplay: {
      delay: 10000,
    },
    spaceBetween: 32,
    roundLengths: true,
  });
}

export { initScreenOffersSlider };
